import React from "react";
import { User, Bell } from "lucide-react";
import "../../assets/css/layout/donor/DonorNavbar.css";
import { useNavigate } from "react-router-dom";

const DonorNavbar = () => {

  const navigate = useNavigate();

  return (
    <header className="donor-navbar">

      {/* LEFT */}
      <div className="navbar-left">
        <h1>Welcome, Donors!</h1>
      </div>

      {/* RIGHT */}
      <div className="navbar-right">

        {/* Notifications */}
        <button
          className="icon-btn"
          onClick={() => navigate("/donor/notificationdropdown")}
          title="NotificationDropdown"
        >
          <Bell size={20} />
        </button>

        {/* Profile */}
        <button
          className="icon-btn profile-icon-wrapper"
          onClick={() => navigate("/donor/profile")}
          title="Profile"
        >
          <User size={20} />
        </button>

      </div>
    </header>
  );
};

export default DonorNavbar;